

export class FreebieModel {
    freebieId?: number;
    freebieCategory: string;
    unitPrice: number;
    freebieDesc: string;
    companyId: number;
    departmentId: number;
    freebieCode: string;
    startHour: number;
    startMinutes: number;
    endHour: number;
    endMinutes: number;
    jobHour: number;
    isActive:boolean;
    createdUser:string;
    // startTime:Date;
    // endTime:Date;

    /**
     * 
     * @param freebieId 
     * @param freebieCategory 
     * @param unitPrice 
     * @param freebieDesc 
     * @param companyId 
     * @param departmentId 
     * @param freebieCode 
     * @param startHour 
     * @param startMinutes 
     * @param endHour 
     * @param endMinutes 
     * @param username 
     * @param isActive
     */
    constructor(freebieId: number, freebieCategory: string, unitPrice: number, freebieDesc: string, companyId: number, departmentId: number, freebieCode: string, startHour: number, startMinutes: number, endHour: number, endMinutes: number, jobHour: number,isActive:boolean,createdUser:string) {
        this.freebieId = freebieId;
        this.freebieCategory = freebieCategory;
        this.unitPrice = unitPrice;
        this.freebieDesc = freebieDesc;
        this.companyId = companyId;
        this.departmentId = departmentId;
        this.freebieCode = freebieCode;
        this.startHour = startHour;
        this.startMinutes = startMinutes;
        this.endHour = endHour;
        this.endMinutes = endMinutes;
        this.jobHour = jobHour;
        this.isActive=isActive;
        // this.startTime = startTime;
        // this.endTime = endTime;
        this.createdUser = createdUser;
    }
}